import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "mb-3 mb-lg-4" }, "Your Order", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-secondary" }, "Ordered items", -1)),
        _createVNode(_component_RouterLink, {
          to: "/ecommerce/cart",
          class: "text-primary text-decoration-none"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Edit Cart ", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"default-table-area\"><div class=\"table-responsive\"><table class=\"table align-middle\"><thead><tr><th scope=\"col\">Description</th><th scope=\"col\" class=\"text-end\">Price</th></tr></thead><tbody><tr><td>Grand Total :</td><td class=\"text-end\">$0.00</td></tr><tr><td>Discount :</td><td class=\"text-end\">$0.00</td></tr><tr><td>Tax :</td><td class=\"text-end\">$0.00</td></tr><tr><td class=\"text-secondary fw-medium\">Subtotal :</td><td class=\"text-secondary fw-medium text-end\">$0.00</td></tr><tr><td>Shipping Charge :</td><td class=\"text-end\">$0.00</td></tr><tr><td>Coupon Charge :</td><td class=\"text-secondary text-end\">$0.00</td></tr><tr><td class=\"text-secondary fw-medium\">Total :</td><td class=\"text-secondary fw-medium text-end\">$0.00</td></tr></tbody></table></div></div>", 1))
    ])
  ]))
}